/* src/app/components/controls/charts/graphs/sem-line-graph/sem-line-graph.component.css */
.chart-info {
  padding: 0 0 12px 0;
}
.chart-info p {
  margin: 0;
}
ngx-charts-line-chart,
.chart-empty-state {
  display: block;
  max-width: 100%;
  overflow: hidden;
}
:host {
  display: block;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
/*# sourceMappingURL=sem-line-graph.component.css.map */
